import { render, staticRenderFns } from "./transactionsreport.vue?vue&type=template&id=33fc81ad"
import script from "./transactionsreport.vue?vue&type=script&lang=js"
export * from "./transactionsreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports